import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material';
import { MockupPreviewComponent } from '../mockup-preview/mockup-preview.component';
import { PhotosService } from '../services/photos.service';

@Component({
    selector: 'app-instagram-post',
    templateUrl: './instagram-post.component.html',
    styleUrls: ['./instagram-post.component.css']
})
export class InstagramPostComponent implements OnInit {

    instagramPost = [];

    constructor(private photos: PhotosService, public dialog: MatDialog) { }

    ngOnInit() {
        this.instagramPost = this.photos.instagramPost;
    }

    openDialog(url: string): void {
        if (screen.width > 600) {
            this.dialog.open(MockupPreviewComponent, {
                maxHeight: '90%',
                width: '800px',
                data: {url: url}
            });
        }
    }

}
